import { useContext, useMemo } from 'react';
import { LocaleContext } from './context';
import { getLocaleData } from './getLocaleData';
export function useLocale() {
    var contextLocale = useContext(LocaleContext);
    var result = useMemo(function () { return getLocaleData(contextLocale); }, [contextLocale]);
    return result;
}
